<template>
  <el-dialog
    :title="$t('answer.答题')"
    :visible.sync="isShow"
    width="1000px"
    ref="answerDialogs"
    :close-on-click-modal="false"
    :before-close="beforeClose"
    @close="close"
    class="answerDialog"
  >
    <div class="modal-con-col">
      <div class="left-nav">
        <el-scrollbar style="height: calc(100% - 5px)" ref="scrollbarRef">
          <ul id="questionnaire-nav">
            <li
              align="center"
              :class="{ cur: actionTabsKey === 'new' }"
              class="pointer"
              @click="newAnswer"
            >
              + {{ $t('answer.新建答题') }}
            </li>
            <li
              v-for="(itemTab, index) in editableTabs"
              @click="
                clickTabsItem(`${itemTab.webcastAnswerSheetId}`, `${itemTab.confAnswerSheetId}`)
              "
              :class="{ cur: actionTabsKey === `${itemTab.webcastAnswerSheetId}` }"
              :key="index"
              class="questionnaire-nav-item"
            >
              <span v-if="itemTab.answerSheetStateV2 == 0" class="unstart unstart-question">{{
                $t('answer.未发布')
              }}</span
              ><span v-if="itemTab.answerSheetStateV2 == 1" class="publishing">{{
                $t('answer.发布中')
              }}</span
              ><span v-if="itemTab.answerSheetStateV2 == 2" class="unstart">{{
                $t('answer.已终止')
              }}</span
              ><span v-if="itemTab.answerSheetStateV2 == 4" class="unstart">{{
                $t('answer.已结束')
              }}</span>
              <span class="cut"> {{ itemTab.answerSheetTitle }} </span>
            </li>
          </ul>
        </el-scrollbar>
      </div>
      <addOrEdit
        @refreshList="refreshList"
        v-if="showNew"
        :edit-paper="editPaperInfo"
        :edit="isEdit"
        :editableTabs="editableTabs"
        ref="showadd"
      />

      <showInfo
        ref="showInfo"
        v-if="showInfo"
        :answer-id="answerId"
        :conf-answer-id="confWebcastId"
        @deleteTo="deleteTo"
        @editPaper="editPaper"
        @refreshList="refreshList"
      />
    </div>
  </el-dialog>
</template>

<script>
import showInfo from '@/components/toolList/answer/showInfo';
import addOrEdit from '@/components/toolList/answer/addOrEdit';
import { getAnswerSheetList } from '@/api/liveRequest/answerApi';
import { mapGetters } from 'vuex';
import answer from '@/components/toolList/answer/answer';
export default {
  components: {
    showInfo,
    addOrEdit
  },
  mixins: [answer],
  provide() {
    return {
      questionThis: this
    };
  },
  data() {
    return {
      /**试卷id */
      questionId: null,
      //answerDialogs: false,
      editableTabsValue: '1',
      editableTabs: [],
      TabsHistory: [],
      tabIndex: 1,
      tabsIndex: 1,
      type: '',
      actionTabsKey: 'new',
      actionTabsObj: null,
      showInfoState: false,
      loadingState: false,
      showNew: true,
      showInfo: false,
      editPaperInfo: {},
      isEdit: false,
      isShow: false,
      confWebcastId: ''
    };
  },
  watch: {
    isShowAnswerSheet: {
      immediate: true,
      handler: function (value) {
        console.log(value, 'value');
        if (value) {
          this.getPaperListFunc();
        }
        this.isShow = value;
      }
    }
  },
  computed: {
    ...mapGetters(['isShowAnswerSheet']),
    liveToken() {
      return this.$store.getters.liveToken;
    }
  },
  methods: {
    close() {
      this.$store.commit('SET_SHOW_ANSWERSHEET', false);
    },
    editPaper(paper) {
      this.newAnswer();
      console.log(paper, 'edit paper 主index');
      this.editPaperInfo = paper;
      this.isEdit = true;
    },
    deleteTo() {
      this.newAnswer();
      this.refreshList();
    },
    newAnswer() {
      this.showNew = true;
      this.showInfo = false;
      this.actionTabsKey = 'new';
      this.tempKey = '';
      this.isEdit = false;
    },
    refreshList() {
      this.getPaperListFunc();
      if (this.tempKey !== '') {
        this.showNew = false;
        this.showInfo = true;
        this.actionTabsKey = this.tempKey;
        this.answerId = this.tempKey;
        this.confPaperId = this.tempConfId;
      }
    },
    /**初始化 */
    init() {
      this.actionTabsKey = 'new';
      this.showInfoState = false;
      this.actionTabsObj = null;
      this.getPaperListFunc();
      //console.log(this.isShowAnswer, "showAnswer");
    },
    /**点击列表访问对应问卷 */
    clickTabsItem(webcastId, confWebcastId) {
      console.log(webcastId, 'webcastId');
      // this.showNew = false;
      // this.showInfo = true;
      // this.actionTabsKey = webcastId;
      // this.answerId = webcastId;
      this.confWebcastId = confWebcastId;
      if (this.actionTabsKey === 'new' && !this.isWrite()) {
        this.confirmClick(webcastId, confWebcastId);
      } else {
        this.toPaper(webcastId, confWebcastId);
      }
    },
    /**获取答题列表 */
    getPaperListFunc() {
      //this.loadingState = true
      console.log(this.$route.query.liveId);
      getAnswerSheetList(
        {
          webcastId: this.$route.query.liveId,
          createTypes: '0,1'
        },
        this.liveToken
      )
        .then((res) => {
          console.log(res, 'getPaperList');
          if (res.code === 200) {
            this.editableTabs = res.data;
          }
          this.loadingState = false;
        })
        .catch((err) => {
          console.log(err, 'err_getPaperList');
          this.loadingState = false;
        });
    },

    refreshPaper() {
      this.$refs.showInfo.getPaperInfoFunc();
    }
  },
  created() {}
};
</script>
<style scoped lang="scss">
.pointer {
  cursor: pointer;
}
.left-nav ::v-deep .el-scrollbar__wrap {
  overflow-x: hidden;
}
.right-con ::v-deep .el-scrollbar__wrap {
  overflow-x: hidden;
}
.answerDialog ::v-deep {
  .el-dialog__body {
    padding: 0px;
    height: 520px;
  }
  .el-dialog__header {
    background: $dialog-bg-color;
    color: $grey3-color;
  }
  .el-dialog__title {
    color: $grey3-color;
  }
  .el-dialog__body {
    background: $dialog-bg-color;
  }
  .el-input__inner {
    background-color: $purple6-color;
    border-color: #525366;
    color: #fff;
  }
  .el-form-item__label {
    padding-right: 0;
    color: #fff;
    font-size: 12px;
  }
  .el-input .el-input__count .el-input__count-inner {
    background-color: $purple6-color;
    color: #acb2bf;
  }
  .el-button--mini {
    border-radius: 6px;
  }
  .el-button--primary.is-disabled {
    background: #3986ee;
    border-color: #3986ee;
    opacity: 0.5;
  }
}
.modal-con-col {
  display: flex;
}
.left-nav {
  width: 240px;
  color: $white-color;
  font-size: 14px;
  height: 420px;
  li {
    height: 48px;
    line-height: 48px;
  }
  .cur {
    background: $back-answer-color;
  }
}
// .left-nav ::v-deep .el-scrollbar__wrap {
//   overflow-x: hidden;
// }
.right-con ::v-deep .el-scrollbar__wrap {
  overflow-x: hidden;
}
.answerTabs ::v-deep .is-left {
  font-size: 12px;
}
.bottom-link {
  width: 140px;
  position: absolute;
  bottom: 16px;
  background-color: #f1f1f1;
  text-align: center;
  font-size: 12px;
}

.addAnswerFrom ::v-deep .el-form-item__label {
  font-size: 12px;
}
.addAnswerFrom ::v-deep .el-form-item__content {
  line-height: 0px;
}
.addInputLong {
  width: 86%;
  text-align: center;
}
.addInputLongItem {
  width: 74%;
  text-align: center;
  margin-bottom: 6px;
}

.addMoreanswer .input-title-sm {
  width: 80px;
}
.questionnaire-nav-item {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding-left: 8px;
}
.unstart {
  color: $grey3-color;
  height: 20px;
  line-height: 16px;
  border-radius: 293px;
  font-size: 10px;
  padding: 2px 5px;
  margin-right: 5px;
  position: relative;
  box-sizing: border-box;
  background-color: rgba(125, 127, 140, 0.2);
}
.unstart-question {
  color: $bule-color;
  background-color: rgba(57, 134, 238, 0.2);
}
.publishing {
  color: $green3-color;
  height: 20px;
  line-height: 16px;
  border-radius: 293px;
  font-size: 10px;
  padding: 2px 5px;
  margin-right: 5px;
  position: relative;
  box-sizing: border-box;
  background-color: rgba(135, 238, 57, 0.2);
}
.cut {
  display: inline-block;
  width: 58%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
}
::v-deep .el-dialog__header{
  padding: 15px 20px;
}
</style>
<style lang="scss">
.el-select-dropdown {
  background: $back-answer-color;
  color: $white-color;
}
// .el-select-dropdown__item.hover,
// .el-select-dropdown__item:hover {
//   background: $back-answer-color;
// }

.el-dialog__header {
  background: $dialog-bg-color;
  color: $grey3-color;
}
.el-dialog__title {
  color: $grey3-color;
}
.el-dialog__body {
  background: $dialog-bg-color;
}
.el-dialog__footer {
  background: $dialog-bg-color;
}
.el-input-group__prepend {
  background: $back-answer-color;
}
</style>
